export default "__VITE_ASSET__Bd0DicNE__"